import { Column } from "@components/Layout";
import { type JSX, type ParentComponent, Show } from "solid-js";
import { MenuItemWrapper } from "./styled";

const MenuItem: ParentComponent<{
	href: string;
	icon: JSX.Element;
	w?: JSX.CSSProperties["width"];
	onClick?: () => void;
	settings?: boolean;
	state?: object;
}> = (props) => {
	return (
		<MenuItemWrapper
			href={props.href}
			w={props.w}
			onclick={props.onClick}
			settings={props.settings}
			state={props.state}
		>
			<Column w="max-content">{props.icon}</Column>
			<Show when={typeof props.children === "string"} fallback={props.children}>
				<h3>{props.children}</h3>
			</Show>
		</MenuItemWrapper>
	);
};
export default MenuItem;
